// extracted by mini-css-extract-plugin
export default {"ToggleContainer":"estilo_ToggleContainer__CqLCC","Indicador":"estilo_Indicador__bokHF","Descricao":"estilo_Descricao__H4UIC"};